export default "__VITE_ASSET__DhvvW39g__"